import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers";

// keep this ONLY if you're actually using history somewhere
// import { createBrowserHistory } from "history";
// export const history = createBrowserHistory();

const store = configureStore({
  reducer: reducers,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // TEMP: avoid warnings in your app
      immutableCheck: false, // TEMP: avoid warnings
    }),

  devTools: process.env.NODE_ENV !== "production",
});

export default store;
